import store from "@/store";
import {getFileInfoByKeySvrUrl} from "@/api/file_info_sync";
import {getTranslationSvrUrl} from "@/api/file_translation";


export function fileStatusChange(fileInfo, status, statusCode) {
    if (status) {
        fileInfo.status = status;

    }
    if (statusCode) {
        fileInfo.status_code = statusCode;
    }
    store.commit("addStatusChangeSign")
}


export function isPathMatch(pathStr, match_file_word_list) {
    if (!pathStr || !match_file_word_list || match_file_word_list.length === 0) {
        return false; // 如果路径字符串或忽略列表为空，则不忽略
    }

    for (const matchItem of match_file_word_list) {
        try {
            // 尝试将 matchItem 视为正则表达式
            const regex = new RegExp(matchItem, "i");
            console.log("isPathMatch", matchItem, pathStr, regex.test(pathStr));
            if (regex.test(pathStr)) {
                return true; // 路径字符串匹配正则表达式
            }
        } catch (error) {
            // 如果 matchItem 不是有效的正则表达式，则将其视为字符串
            if (pathStr.includes(matchItem)) {
                return true; // 路径字符串包含字符串
            }
        }
    }

    return false; // 路径字符串不包含任何忽略的关键字或匹配任何正则表达式
}


export function isAllowed(pathStr, fileType, allow_file_type, allow_file_path_word, not_allow_file_type, not_allow_file_path_word) {

    // 1. 黑名单检查 (not_allow) - 优先
    if (isPathMatch(pathStr, not_allow_file_path_word) || not_allow_file_type.includes(fileType)) {
        console.log("isAllowed false black",)
        return false; // 路径或文件类型在黑名单中，直接拒绝
    }

    // 2. 白名单检查 (allow)
    if (allow_file_type.length > 0 && !allow_file_type.includes(fileType)) {
        console.log("isAllowed false no type in white",)
        return false; // 文件类型不在白名单中，拒绝

    }

    if (allow_file_path_word.length > 0 && !isPathMatch(pathStr, allow_file_path_word)) {
        console.log("isAllowed false no path in white", allow_file_path_word, pathStr)
        return false; // 路径不在白名单中，拒绝
    }

    // 3. 如果没有明确的白名单规则，则接受
    return true;
}


export function getFileExtension(filePath) {
    // 使用正则匹配最后的后缀
    const match = filePath.match(/\.([^./\\]+)$/);
    return match ? match[1] : "";
}

//todo 将fileInfo状态改为 数值
export async function pollingRefreshFileInfo(fileInfo, breakFunction = null, callback = null,
                                             maxAttempts = 60, interval = 6000) {
    const apiUrl = getFileInfoByKeySvrUrl(fileInfo.project_id, fileInfo.file_key, fileInfo.root_key, fileInfo.file_hash);

    let finalData;
    let attempts = 0;

    while (attempts < maxAttempts) {
        try {
            const response = await fetch(apiUrl);
            finalData = await response.json();
            if (breakFunction) {
                if (breakFunction(finalData)) {
                    break
                }
            } else if (finalData.status_code > 800) {
                break;
            }
        } catch (error) {
            console.error("Error fetching parse result:", error);
        }

        attempts++;
        await new Promise(resolve => setTimeout(resolve, interval)); // Wait before retrying
    }

    if (finalData) {
        // console.log('Polling finished with result:', finalData);
        if (callback) {
            callback(finalData);
        }
    } else {
        console.warn("Polling failed to reach 'parsed' status after multiple attempts.");
        fileStatusChange(fileInfo, "failed"); // Or handle the failure appropriately
    }
}

export async function pollingFileTranslation(fileInfo, breakFunction = null, callback = null,
                                             maxAttempts = 60, interval = 6000) {
    const apiUrl = getTranslationSvrUrl(fileInfo.translation_task_id, fileInfo.root_key, fileInfo.file_hash);

    let finalData;
    let attempts = 0;

    while (attempts < maxAttempts) {
        try {
            const response = await fetch(apiUrl);
            finalData = await response.json();
            if (breakFunction) {
                if (breakFunction(finalData)) {
                    break
                }
            } else if (finalData.status_code > 800) {
                break;
            }
        } catch (error) {
            console.error("Error fetching parse result:", error);
        }

        attempts++;
        await new Promise(resolve => setTimeout(resolve, interval)); // Wait before retrying
    }

    if (finalData) {
        // console.log('Polling finished with result:', finalData);
        if (callback) {
            callback(finalData);
        }
    } else {
        console.warn("Polling failed to reach translation after multiple attempts.");
        // fileStatusChange(fileInfo, "failed"); // Or handle the failure appropriately
    }
}

export function isSubset(subArray, arrayBig) {
    // console.log("isSubset", subArray, arrayBig);
    return subArray.every(item => arrayBig.includes(item));
}

export function extractAndParseJsonFromBox(llmResponseString) {
    // 1. 基础校验：确保输入是有效的、非空的字符串
    if (typeof llmResponseString !== 'string' || llmResponseString.trim() === '') {
        console.warn("输入不是一个有效的字符串，或为空。");
        return {};
    }

    try {
        // 2. 定位 <Answer> 标签
        const answerTag = '<Answer>';
        let answerIndex = llmResponseString.indexOf(answerTag);

        if (answerIndex === -1) {
            console.warn("未能找到 <Answer> 标签，直接进行全局匹配。");
            answerIndex = 0
        } else {
            answerIndex = answerIndex + answerTag.length
        }


        // 3. 定义搜索区域为 <Answer> 标签之后的所有内容
        const searchArea = llmResponseString.slice(answerIndex);

        let jsonSearchTarget = ''; // 将在其中寻找 JSON 的最终目标字符串

        // 4. 优先尝试匹配 <box>...</box>
        const boxMatch = searchArea.match(/<box>(.*?)<\/box>/s);

        if (boxMatch && boxMatch[1]) {
            // 成功路径：找到了 <box> 标签
            jsonSearchTarget = boxMatch[1];
        } else {
            // 回退路径：未找到 <box>，使用 <Answer> 之后的所有内容
            console.warn("在 <Answer> 之后未能找到 <box> 结构。将尝试直接在 <Answer> 后的全部内容中查找 JSON。");
            jsonSearchTarget = searchArea;
        }

        // 5. 定位核心：在目标字符串中找到最外层的花括号
        const firstBraceIndex = jsonSearchTarget.indexOf('{');
        const lastBraceIndex = jsonSearchTarget.lastIndexOf('}');

        // 确保找到了一个有效的、顺序正确的 {...} 结构
        if (firstBraceIndex === -1 || lastBraceIndex === -1 || lastBraceIndex < firstBraceIndex) {
            console.warn("在目标区域中未能找到一个有效的最外层JSON对象结构 '{...}'。");
            return {};
        }

        // 6. 提取和解析：提取花括号之间的内容并尝试解析
        const jsonCandidate = jsonSearchTarget.slice(firstBraceIndex, lastBraceIndex + 1);

        let res = {}
        try {
            res = JSON.parse(jsonCandidate);
        } catch (err) {
            console.log(`最终解析json 失败，失败原因:${err}, 区间:${firstBraceIndex}, ${lastBraceIndex} ;解析内容:${jsonCandidate}; `, `jsonSearchTarget: ${jsonSearchTarget}`);
        }
        return res

    } catch (error) {
        // 7. 错误处理：捕获任何异常（主要是JSON.parse失败）
        console.error("提取或解析JSON时发生错误:", error.message, "原始输入:", llmResponseString);
        return {};
    }
}

export function openImageWindowWithBox(targetUrl, box) {
    const baseUrl = window.location.href.split('#')[0];
    const newRoute = '#/location';
    const params = new URLSearchParams({
        img_url: targetUrl,
        box: JSON.stringify(box)
    }).toString();
    const finalUrl = `${baseUrl}${newRoute}?${params}`;
    window.electronAPI.openLocationWindow(finalUrl);
}

export async function locationByPathKeyword(filePath, keyword) {
    const baseUrl = window.location.href.split('#')[0];
    const newRoute = '#/location';
    const finalUrl = `${baseUrl}${newRoute}`;
    store.commit("setLocationPath", filePath);

    store.commit("setLocationKeyword", keyword);
    store.commit("setLocationTab", "location");
    await store.dispatch("syncWindowState")
    // store.commit("addLocationStateSign")
    window.electronAPI.openLocationWindow(finalUrl);
    console.log("locationByPathKeyword:", store.state.locationPath, store.state.locationKeyword);
}

export async function toTranslationView(filePath) {
    const baseUrl = window.location.href.split('#')[0];
    const newRoute = '#/location';
    const finalUrl = `${baseUrl}${newRoute}`;
    store.commit("setLocationPath", filePath);
    store.commit("setLocationTab", "translation");
    await store.dispatch("syncWindowState")
    window.electronAPI.openLocationWindow(finalUrl);
    console.log("locationByPathKeyword:", store.state.locationPath, store.state.locationKeyword);
}

export function getOrgImageKeys(fileInfo) {
    const res = []
    fileInfo.file_vision.forEach(visionRes => {
        if (visionRes['img_key']) {
            res.push(visionRes['img_key'])
        }
    })
    return res
}

export function getBaseName(filePath) {
    // 1. 获取路径中最后一部分 (文件名)
    //    替换所有反斜杠为正斜杠，然后按正斜杠分割
    const parts = filePath.replace(/\\/g, '/').split('/');
    const fileName = parts[parts.length - 1];

    // 2. 移除最后一个点之后的后缀
    const lastDotIndex = fileName.lastIndexOf('.');

    // 如果没有点，或者点是第一个字符 (如 ".bashrc")，则不处理，直接返回完整文件名
    if (lastDotIndex <= 0) {
        return fileName;
    }

    return fileName.substring(0, lastDotIndex);
}

export function generateInputMarkdown(data) {
    // 移除了 Output Schema 列，因为我们通过 Prompt 统一规定了输出格式，
    // 这样能进一步节省约 20-30% 的 Token

    const headers = ["Keyword", "Type", "Constraints", "Description"];

    let md = `| ${headers.join(" | ")} |\n`;
    md += `| ${headers.map(() => "---").join(" | ")} |\n`;

    const clean = (text) => String(text || "").replace(/\|/g, "\\|").replace(/[\r\n]+/g, " ");

    data.forEach(item => {
        let constraints = "";
        if (item.enumeration?.length) constraints = `Enum: ${item.enumeration.join(", ")}`;
        else if (item.unit_options?.length) constraints = `Unit: ${item.unit_options.join(", ")}`;
        else if (item.type === 'range') constraints = "Range (Min/Max)";

        const row = [
            clean(item.keyword),
            clean(item.type),
            clean(constraints),
            clean(item.description)
        ];
        md += `| ${row.join(" | ")} |\n`;
    });

    return md;
}

export function parseOutputMarkdown(llmOutput) {
    // 1. 构建类型映射表，方便查询 keyword 对应的 type
    const originalConfig = store.state.mainConfig.params
    const configMap = {};
    originalConfig.forEach(item => {
        configMap[item.keyword] = item.type;
    });

    // 2. 提取 <box> 标签内的内容
    // 使用非贪婪匹配，如果没有标签则回退到处理整个字符串（防止模型偶尔忘写标签）
    const boxMatch = llmOutput.match(/<box>([\s\S]*?)<\/box>/i);
    const markdownContent = boxMatch ? boxMatch[1] : llmOutput;

    // 3. 按行分割并解析
    const lines = markdownContent.trim().split('\n');
    const tempResults = {}; // 用于临时存储和聚合

    // 正则：匹配 Markdown 表格行，忽略首尾的 |
    const rowRegex = /^\|(.+)\|$/;

    // 定位表头结束的位置 (寻找分隔线 |---|---|)
    let startIndex = 0;
    for (let i = 0; i < lines.length; i++) {
        if (lines[i].includes('---')) {
            startIndex = i + 1;
            break;
        }
    }

    for (let i = startIndex; i < lines.length; i++) {
        const line = lines[i].trim();
        const match = line.match(rowRegex);

        if (match) {
            // 分割单元格并去除空白，处理转义的 \|
            const cells = match[1].split('|').map(cell => cell.trim());

            // 确保列数足够 (Keyword, Value/Min, Max, Unit, Source)
            if (cells.length >= 5) {
                const keyword = cells[0];
                const valueOrMin = cells[1]; // 对于非 range 类型，这就是 value
                const max = cells[2];
                const unit = cells[3];
                const sourceText = cells[4];

                // 简单的有效性检查：必须有 Keyword，且 (Value 或 Max 必须有值)
                if (!keyword || (!valueOrMin && !max)) continue;

                // 构造标准提取对象
                const extractionData = {
                    value: valueOrMin, // 默认填充到 value
                    min: valueOrMin,   // 同时填充 min (兼容 range)
                    max: max,
                    unit: unit,
                    sourceText: sourceText
                };

                const fieldType = configMap[keyword];

                // --- 聚合逻辑 ---
                if (fieldType === 'text') {
                    // 如果是 text 类型，我们需要收集所有条目
                    if (!tempResults[keyword]) {
                        tempResults[keyword] = []
                    }
                    tempResults[keyword].push({
                        keyword: keyword,
                        ...extractionData
                    });
                } else {
                    // 如果模型输出多行，后面的覆盖前面的
                    tempResults[keyword] = {
                        keyword: keyword,
                        ...extractionData
                    };
                }
            }
        }
    }

    return tempResults;
}


/**
 * 将 JSON 数组列表逆向生成为 Markdown 表格字符串
 * @param {Array} jsonList - 包含 type, keyword, value, min, max 等字段的数组
 * @returns {string} - 包裹在 <box> 标签内的 Markdown 字符串
 */
export function generateOutputMarkdown(jsonList) {
    // 0. 安全检查：如果不是数组，直接返回空 box
    if (!Array.isArray(jsonList)) {
        return '<box>\n</box>';
    }

    // 1. 初始化表格头部
    // 对应 parse 函数的列顺序：Keyword, Value/Min, Max, Unit, Source
    const rows = [];
    rows.push('| 目标字段 | 值/最小值 | 最大值 | 单位 | 原文依据 |');
    rows.push('| :--- | :--- | :--- | :--- | :--- |');

    // 辅助函数：处理特殊字符（主要是转义 |），并处理 null/undefined
    const formatCell = (content) => {
        if (content === null || content === undefined) return '';
        // 替换竖线，去除首尾空格，防止换行符破坏表格
        return String(content).replace(/\|/g, '\\|').replace(/\n/g, ' ').trim();
    };

    // 2. 遍历数组生成行
    jsonList.forEach(item => {
        const keyword = formatCell(item.keyword);
        const max = formatCell(item.max);
        const unit = formatCell(item.unit);
        const sourceText = formatCell(item.sourceText);

        // --- 核心逻辑：决定第二列显示什么 ---
        let valueColumnContent = '';

        if (item.type === 'range') {
            // 如果是范围类型，第二列语义为 Min
            // 优先取 min，如果 min 为空但 value 有值（容错），则取 value
            valueColumnContent = (item.min !== undefined && item.min !== '')
                ? item.min
                : item.value;
        } else {
            // 其他类型（text, select, boolean等），第二列语义为 Value
            // 优先取 value，如果 value 为空但 min 有值（容错），则取 min
            valueColumnContent = (item.value !== undefined && item.value !== '')
                ? item.value
                : item.min;
        }

        const valueOrMin = formatCell(valueColumnContent);

        // 拼接成 Markdown 行
        rows.push(`| ${keyword} | ${valueOrMin} | ${max} | ${unit} | ${sourceText} |`);
    });

    // 3. 组合最终字符串并包裹标签
    return `<box>\n${rows.join('\n')}\n</box>`;
}

export function parseTaskKeyIsKv(taskKey) {
    const originalConfig = store.state.mainConfig.params
    const configMap = store.state.mainConfig.params_map
    const label_to_param_config = store.state.mainConfig.label_to_param_config
    if (!label_to_param_config[taskKey]) {
        console.log("label_to_param_config ", label_to_param_config, taskKey)
    }
    const taskKeywords = label_to_param_config[taskKey].params

    for (let i = 0; i < taskKeywords.length; i++) {
        const keyword = taskKeywords[i]
        if (["str", "range", "int", "enumeration"].includes(configMap[keyword].type)) {
            return true
        }
        if (["table"].includes(configMap[keyword].type)) {
            return false
        }
    }
    return true
}


function _getPromptKey(imageIndex, label){
    return `${imageIndex}_${label}`
}

function getVisionPromptMap(fileInfo) {
    const res = {}
    const getImageIndex = (imageKey) => {
        for (let i = 0; i < fileInfo.file_vision.length; i++) {
            if (fileInfo.file_vision[i].img_key === imageKey) {
                return i
            }
        }
        throw `unexpected image key: ${imageKey}`
    }

    for (let i = 0; i < fileInfo.file_analyse_log.length; i++) {
        const logItem = fileInfo.file_analyse_log[i];
        const imageKey = logItem.prompt[0]["image_keys"][0]
        const label = logItem.task_key
        const imageIndex = getImageIndex(imageKey);
        const key = _getPromptKey(imageIndex, label)
        res[key] = {"label": label, "imageIndex": imageIndex, "prompt": logItem.prompt, "image_key": imageKey};
    }

    return res
}


export function getFileInfoSampleData(fileInfo) {
    console.log("--- DEBUG START: getFileInfoSampleData ---");
    const mainConfig = store.state.mainConfig
    // 检查 Config 是否加载
    if (!mainConfig) {
        console.error("!!! Critical: mainConfig is missing");
        return [];
    }
    const labelToParamConfig = mainConfig.label_to_param_config
    const keyword2Label = mainConfig.keyword2Label

    const allRes = []
    const labels = []

    // Check 1: 原始数据循环
    for (const keyword of Object.keys(fileInfo.paramsMap)) {
        const targetParam = fileInfo.paramsMap[keyword]
        if (targetParam.res && targetParam.res.length > 0) {
            console.log("Debug res item:", targetParam.res[0]);
            const currentKeyword = targetParam.keyword;
            const label = keyword2Label[currentKeyword]

            // Log 1: 检查 Label 映射
            if (!label) {
                console.error(`!!! Critical: No label found for keyword: ${currentKeyword}`);
                console.error("unexpect getFileInfoSampleData", targetParam)
                throw `关键词：${currentKeyword} 未定义，请联系研发`// 这里的 return 导致了 undefined
            }

            labels.push(label)
            if (targetParam.type === "text") {
                targetParam.res.forEach(textRes => {
                    allRes.push(textRes)
                })
            } else if (targetParam.type === "table") {
                console.warn(`Warning: Skipping table type for keyword: ${currentKeyword}`);
            } else {
                allRes.push(targetParam.res[0])
            }
        }
    }

    console.log("Step 1 - allRes (Raw Data):", allRes)
    if (allRes.length === 0) console.warn("!!! Warning: allRes is empty. No text data found.");

    const labelSet = [...new Set(labels)]
    const visionPageList = []
    for (let i = 0; i < fileInfo.file_vision.length; i++) {
        const tempObj = {}
        labelSet.forEach(label => {
            tempObj[label] = []
        })
        visionPageList.push(tempObj)
    }

    // Check 2: 数据分配
    labelSet.forEach(label => {
        const labelConfig = labelToParamConfig[label];
        if(!labelConfig) {
             console.error(`!!! Error: No config found for label: ${label}`);
             return;
        }
        const labelContainKeywords = labelConfig['params']

        labelContainKeywords.forEach(containKeyword => {
            allRes.forEach(resItem => {
                if (resItem.keyword === containKeyword) {
                    const imageIndex = resItem.imageIndex
                    if (!visionPageList[imageIndex]) {
                        console.error("!!! Error: unexpected imageIndex", imageIndex);
                        throw new Error(`unexpected image imageIndex: ${imageIndex}`)
                    }
                    visionPageList[imageIndex][label].push(resItem)
                }
            })
        })
    })

    console.log("Step 2 - visionPageList (Sorted Data):", JSON.parse(JSON.stringify(visionPageList)));

    const filePromptInfoMap = getVisionPromptMap(fileInfo)
    const res = []

    // Check 3: 最终组装
    for (let i = 0; i < fileInfo.file_vision.length; i++) {
        const visionPage = visionPageList[i]
        const image_key = fileInfo.file_vision[i].img_key

        labelSet.forEach(label => {
            const labelRes = visionPage[label]
            const promptKey = _getPromptKey(i, label)
            const promptInfo = filePromptInfoMap[promptKey]

            // Log 3: 检查 Prompt 是否存在
            if (!promptInfo) {
                console.warn(`!!! Warning: Missing promptInfo for key [${promptKey}] (Page: ${i}, Label: ${label}). This item will be skipped.`);
            } else {
                res.push({
                    "label": label,
                    "res": labelRes,
                    "format_res": generateOutputMarkdown(labelRes),
                    "prompt": promptInfo.prompt,
                    "image_key": [image_key]
                })
            }
        })
    }

    console.log("Step 3 - Final Result:", res)
    console.log("--- DEBUG END ---");
    return res
}

function executeMacro(preCode, valueCode, context, extraStr="") {
    const keys = Object.keys(context);
    const values = Object.values(context);


    const body = `
        "use strict"; 
        ${preCode};
        return ${valueCode};
    `;
    try {
        const fn = new Function(...keys, body);

        const res =  fn(...values)
        return res;
    } catch (e) {
        console.warn(`${extraStr} 执行出现错误，错误详情: ${e}`);
        return null;
    }
}

export function setThirdRes(thirdId, thirdData, tlData) {
    const context = {
        "thirdData": thirdData,
        "tlData": tlData,
    }

    const valueCode = thirdData[thirdId]['value_code'];
    let preCode = thirdData[thirdId]['pre_code'];
    if (!preCode) {
        preCode = "";
    }
    const execRes = executeMacro(preCode, valueCode, context, thirdId);
    return execRes
}
